import { syntaxTree } from '@codemirror/language';
import { hoverTooltip } from '@codemirror/view';
import { Identifier, LabelMatchers, QuotedLabelName } from '../../lezer/parser.terms';
import { PrometheusMetadataClient } from '../client/metadata';
import { getMetadataTooltipDOM, withPadding } from '../utils/promql-metadata-tooltip-content';

export function promQLTooltipExtension({ client }: { client: PrometheusMetadataClient }) {
  const metadataClient = client;
  return hoverTooltip(
    async (view, pos) => {
      // get current node
      const node = syntaxTree(view.state).resolve(pos, -1);

      if (!node.type.is(Identifier) && !node.type.is(QuotedLabelName)) {
        return null;
      }

      if (node.type.id === QuotedLabelName && node.parent?.type.id != LabelMatchers) {
        // Label, not metric name.
        return null;
      }

      let startPos = node.from;
      let endPos = node.to;
      if (node.type.is(QuotedLabelName)) {
        startPos = node.from + 1;
        endPos = node.to - 1;
      }
      const metricName = view.state.sliceDoc(startPos, endPos);
      return {
        pos: startPos,
        end: endPos,
        create: () => {
          const div = document.createElement('div');
          div.className = 'cm-tooltip';
          div.innerHTML = withPadding(`Loading metric metadata...`);

          metadataClient
            .getMetricInfo(metricName)
            .then((info) => {
              const subType = info?.subType;
              const type = info?.type;
              const description = info?.description;
              const descriptionSource = info?.descriptionSource;
              const expandedQuery = info?.expandedQuery;

              const onExpandQuery = () => {
                view.dispatch({
                  changes: {
                    from: node.from,
                    to: node.to,
                    insert: expandedQuery,
                  },
                });
              };

              const metadataEl = getMetadataTooltipDOM(
                {
                  metricName,
                  type: type ?? undefined,
                  descriptionSource: descriptionSource ?? undefined,
                  description: description ?? undefined,
                  subType: subType ?? undefined,
                  expandedQuery: expandedQuery ?? undefined,
                  onExpandQuery,
                },
                {
                  padding: '8px',
                }
              );

              // replace div with metadataEl
              div.replaceWith(metadataEl);
            })
            .catch(() => {
              console.error('Failed to load metric metadata', metricName);
              div.innerHTML = withPadding(`Failed to load metric metadata`);
            });

          return {
            dom: div,
          };
        },
      };
    },
    {
      hideOnChange: true,
    }
  );
}
